import appAuth from '../app-auth.js';
import { startLoading, endLoading } from './app-dux';
import { fetchGql } from '../utils/fetch-gql';

/*******************************************************************************
 * Initial state
 */
const initialState = {
    companies: [],
    activeCompanyId: '',
    companiesLoading: false,
    companiesLoaded: false,
    company: {
        name: '',
        companyBranding: {
            primaryColor: '',
            primaryLogo: '',
            secondaryColor: '',
            secondaryLogo: ''
        }
    }
};

/*******************************************************************************
 * Non-async action types
 */
const SET_STATE = 'company/setState';


/*******************************************************************************
 * Reducer
 */
export default function companyReducer( state = initialState, action ) {

    switch ( action.type ) {
        case SET_STATE: {
            return {
                ...state,
                ...action.state
            };
        }

        default:
            return state;
    }
}

/*******************************************************************************
 * Action creators
 */
function setState( state ) {
    return {
        type: SET_STATE,
        state
    };
}

export const loadCompanies = () => async( dispatch, getState ) => {
    dispatch( setState( {
        companiesLoading: true
    } ) );

    const gqlQuery = `query { companyList {
                            id
                            name
                        }
                    }`;

    try {
        const { data, errors } = await fetchGql( gqlQuery );

        if ( errors ) {
            throw new Error( errors );
        }

        dispatch( setState( {
            companies: ( data.companyList || [] )
                .sort( ( a, b ) => a.name.localeCompare( b.name,
                    'en', { 'sensitivity': 'base' } ) ),
            companiesLoaded: true,
            companiesLoading: false
        } ) );

        return data.companyList;
    } catch ( err ) {
        console.log( 'ERROR loading company list:', err );
        dispatch( setState( {
            companies: [],
            companiesLoaded: true,
            companiesLoading: false
        } ) );

        return [];
    }
};

export const loadCompany = ( companyId ) => async ( dispatch ) => {
    const gqlQuery = `query { 
                        company {
                            name,
                            id,
                            companyBranding {
                                primaryColor,
                                primaryLogo,
                                secondaryColor,
                                secondaryLogo
                            }
                        }
                    }`;

    dispatch( startLoading() );

    try {
        const { data, errors } = await fetchGql( gqlQuery );

        if ( errors ) {
            throw new Error( errors );
        }
        dispatch( setState( {
            company: data.company
        } ) );

        return data;
    } catch ( err ) {
        console.log( 'ERROR while loading company:', err );
        dispatch( setState( {
            company: initialState.company,
            companiesLoading: false
        } ) );

        return initialState.activeCompany;
    } finally {
        dispatch( endLoading() );
    }
};

export const setCompany = ( companyId ) => {
    return async( dispatch, getState ) => {
        if ( getState().companyData.activeCompanyId !== companyId ) {
            if ( companyId ) {
                dispatch( loadCompany( companyId ) );
                dispatch( setState( { activeCompanyId: companyId } ) );
                await appAuth.delegate( companyId );
            } else {
                dispatch( unloadCompany() );
            }
        }
        return Promise.resolve();
    };
};

const unloadCompany = () => {
    return ( dispatch ) => {
        dispatch( setState( {
            company: initialState.company,
            companiesLoading: false
        } ) );
    };
};